/**
 * Formats a product price with currency awareness.
 *
 * - `null`/`undefined` price → `""` (callers omit the price line rather than rendering `$NaN`).
 * - A valid ISO-4217 currency code → `Intl.NumberFormat` currency style (e.g. `US$220.00`, `¥1,200`).
 * - Missing/invalid currency → the legacy `$` + fixed-2 fallback, preserving prior behavior.
 */
export function formatPrice(price: number | null | undefined, currency?: string): string {
  if (price == null) return "";

  const code = currency?.trim().toUpperCase();
  if (code && /^[A-Z]{3}$/.test(code)) {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(price);
    } catch {
      // Not a real ISO-4217 code — fall through to the plain fallback.
    }
  }

  return `$${price.toFixed(2)}`;
}
